export enum ReportsSubpageMessages {
  SCHEDULE_REPORTS_BUTTON = 'Schedule a report',
  EXPORT_LIST_BUTTON = 'Export list',
  COLUMN_SETTINGS_BUTTON = 'Column settings',
}
